import { createFileRoute, notFound, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/$owner/agents/$agentId/$")({
	beforeLoad: ({ params, location }) => {
		// Saved approval and provider-error links still address the former
		// configuration pages. Preserve the proposal run and selected item when
		// opening their sections on the one agent page.
		const [section, detail, ...rest] = location.pathname
			.replace(/\/$/, "")
			.split("/")
			.slice(4);
		if (
			rest.length ||
			!["settings", "models", "skills", "guardrails", "permissions"].includes(
				section,
			) ||
			(detail &&
				(detail === "create" || !["skills", "guardrails"].includes(section)))
		)
			throw notFound();
		throw redirect({
			to: "/$owner/agents/$agentId",
			params: { owner: params.owner, agentId: params.agentId },
			search: {
				...location.search,
				...(detail
					? {
							[section === "skills" ? "skill" : "guardrail"]:
								decodeURIComponent(detail),
						}
					: {}),
			},
			hash: section,
			replace: true,
		});
	},
});
